import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./TestimonialsSection.css";
import googleLogo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";

const testimonials = [
  {
    name: "Merve Sentürk",
    letter: "M",
    color: "#b24e4e",
    textKey: "testimonialsSection.items.0.text",
  },
  {
    name: "Sakia Beltz",
    letter: "S",
    color: "#7a007a",
    textKey: "testimonialsSection.items.1.text",
    featured: true,
  },
  {
    name: "Nourhan Kamer",
    letter: "N",
    color: "#f44fc9",
    textKey: "testimonialsSection.items.2.text",
  },
  {
    name: "Ali Said",
    letter: "A",
    color: "#007bff",
    textKey: "testimonialsSection.items.3.text",
  },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);

  return (
    <section className="testimonials-section py-5">
      <Container>
        <h2
          className="text-center section-title  text-orange fw-bold"
          data-aos="fade-up"
        >
          {t("testimonialsSection.title")} <br /> {t("testimonialsSection.subtitle")}
        </h2>

        <Swiper
          effect="coverflow"
          loop={true}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          slideToClickedSlide={true}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          coverflowEffect={{
            rotate: 10,
            stretch: 0,
            depth: 50,
            modifier: 1,
            slideShadows: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
          }}
          slidesPerGroup={1}
          spaceBetween={30}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`testimonial-card p-4 ${item.featured ? "featured-card" : ""}`}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar-circle me-3"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.letter}
                  </div>
                  <h5 className="mb-0 fw-bold">{item.name}</h5>
                </div>
                <p className="testimonial-text">{t(item.textKey)}</p>
                <div className="d-flex align-items-center gap-2 mt-3">
                  <img src={googleLogo} className="testimonial-img" alt="Google" height={22} />
                  <span className="stars">★★★★★</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
}